import { useEffect } from 'react';
import { Box, Divider, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { formatCurrency } from '@roc/ui/utils';
import { Document } from '@roc/feature-types';
import { observer } from 'mobx-react';
import { useStore } from '@roc/client-portal-shared/hooks';

const useStyles = makeStyles(theme => ({
  sectionTitle: {
    fontWeight: 700,
    fontSize: 15,
  },
  detailLabel: {
    color: theme.palette.text.secondary,
    fontSize: 14,
    width: '35%',
  },
  detailValue: {
    fontWeight: 600,
    fontSize: 14,
  },
}));

export interface LienResolutionContentProps {
  document?: Document;
}

export const LienResolutionContent = observer(
  ({ document }: LienResolutionContentProps) => {
    const classes = useStyles();
    const { titleCommitmentStore } = useStore();
    const { lienResolutionStore } = titleCommitmentStore;
    const lien = lienResolutionStore.currentLien;

    useEffect(() => {
      if (document?.taskId) {
        lienResolutionStore.getLienByTaskId(document.taskId);
      }
    }, [document?.taskId]);

    return (
      <Box mb={2}>
        <Box display="flex" alignItems="center" mb={2}>
          <Typography className={classes.sectionTitle}>
            Resolution Needed
          </Typography>
        </Box>

        <Box display="flex" alignItems="center" py={1.5}>
          <Typography className={classes.detailLabel}>Lien type</Typography>
          <Typography className={classes.detailValue}>
            {lien?.lienType ?? '--'}
          </Typography>
        </Box>
        <Divider />
        <Box display="flex" alignItems="center" py={1.5}>
          <Typography className={classes.detailLabel}>Made by</Typography>
          <Typography className={classes.detailValue}>
            {lien?.madeBy ?? '--'}
          </Typography>
        </Box>
        <Divider />
        <Box display="flex" alignItems="center" py={1.5}>
          <Typography className={classes.detailLabel}>To</Typography>
          <Typography className={classes.detailValue}>
            {lien?.madeTo ?? '--'}
          </Typography>
        </Box>
        <Divider />
        <Box display="flex" alignItems="center" py={1.5}>
          <Typography className={classes.detailLabel}>Dated</Typography>
          <Typography className={classes.detailValue}>
            {lien?.datedDate ?? '--'}
          </Typography>
        </Box>
        <Divider />
        <Box display="flex" alignItems="center" py={1.5}>
          <Typography className={classes.detailLabel}>Recorded</Typography>
          <Typography className={classes.detailValue}>
            {lien?.recordedDate ?? '--'}
          </Typography>
        </Box>
        <Divider />
        <Box display="flex" alignItems="center" py={1.5} mb={1}>
          <Typography className={classes.detailLabel}>Amount</Typography>
          <Typography className={classes.detailValue}>
            {lien?.originalAmount != null
              ? formatCurrency(lien.originalAmount)
              : '--'}
          </Typography>
        </Box>
      </Box>
    );
  }
);
